import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Image from "components/image";
import * as style from "./style.mod.scss";
import RichText from "components/rich-text";
import getImagePath from "helpers/get-image-path";
import OrangeCheckmark from "assets/svgs/Orangehack.svg";
import locale from "locales";
import Money from "components/money";
import ProductReviewsSnippet from "../product-reviews-snippet";
import TableProductInformationMobile from "./index-mobile";

const TableProductInformation = ({ data }) => {
  let productBorderLayout = null;
  let secondProductBorderLayout = null;
  let thirdProductBorderLayout = null;

  const getProductBorderLayout = () => {
    const productComponent = data?.section?.find(
      (component) => component?._type === "productModule"
    );

    if (productComponent && productComponent?.products?.length > 0) {
      const [firstProduct, secondProduct, thirdProduct] = productComponent.products;

      productBorderLayout = firstProduct?.borderLayout?.hex;
      secondProductBorderLayout = secondProduct?.borderLayout?.hex;
      thirdProductBorderLayout = thirdProduct?.borderLayout?.hex;
    }
  };

  const [isImageSelected, setIsImageSelected] = useState(1);

  getProductBorderLayout();

  const getBorderStyle = (j, i, layout, secondLayout, thirdLayout, defaultLayout, productDetailsLength, isImageSelected, newLayout, borderColorHex, columnLength) => {
    const borderStyle = {
      borderLeft: `3px solid ${defaultLayout}`, borderRight: `3px solid ${defaultLayout}`
    };
    const setSelectedBorderStyle = (selectedLayout) => {
      borderStyle.borderLeft = borderStyle.borderRight = `3px solid ${selectedLayout}`;
      if (i === productDetailsLength) borderStyle.borderBottom = `3px solid ${selectedLayout}`;
    };

    if (newLayout) {
      if (j === 0) {
        return {
          borderLeft: `1px solid ${borderColorHex}`, borderTopLeftRadius: `10px`, borderBottomLeftRadius: `10px`, borderBottom: `1px solid ${borderColorHex}`, borderTop: `1px solid ${borderColorHex}`
        };
      }
      if (j === 1) {
        return {
          borderLeft: `3px solid ${borderColorHex}`, borderBottom: `3px solid ${borderColorHex}`, borderTop: `1px solid ${borderColorHex}`, borderRight: `2px solid  ${borderColorHex}`, backgroundColor: `#F7F4F1`
        };
      }
      if (j === columnLength - 1) {
        return {
          borderLeft: `1px solid ${borderColorHex}`, borderRight: `1px solid ${borderColorHex}`, borderBottomRightRadius: `10px`, borderBottom: `1px solid ${borderColorHex}`, borderTop: `1px solid ${borderColorHex}`
        };
      }
      return {
        borderLeft: `1px solid ${borderColorHex}`, borderBottom: `1px solid ${borderColorHex}`, borderTop: `1px solid ${borderColorHex}`,
      };
    }

    if (i === 0 || (i === productDetailsLength && isImageSelected === j)) setSelectedBorderStyle(layout);
    if (i === productDetailsLength && isImageSelected === j) { borderStyle.borderBottomLeftRadius = borderStyle.borderBottomRightRadius = "10px"; borderStyle.margin = "0 0 4rem 0"; }
    if (j >= 1 && j <= 3 && i === i && isImageSelected === j) setSelectedBorderStyle(j === 1 ? layout : j === 2 ? secondLayout : thirdLayout);
    return borderStyle;
  };


  return (
    <>
      <TableProductInformationMobile data={data} />
      <div className={`${style.tableProductInformation} ${style.tableProductInformationDesktop}`}>
        {data?.section?.map((component, i) => {
          const isProductModule = component._type === "productModule";

          if (isProductModule) {
            return (
              <Container key={i}>
                <div className={`${style.productContainer}${data?.newLayout ? ` ${style.productContainerAllBorders}` : ""}`}>
                  <div className={style.emptyBox}></div>
                  {component?.products?.map((prod, j) => {
                    const borderThickness = data?.newLayout && j !== 0 ? "1px" : "3px";
                    const formattedMergedVariants = prod?.prodRef?.clusterVariants;
                    return (
                      <div
                        key={j}
                        style={{
                          borderLeft: data?.newLayout || isImageSelected === j + 1 ? `${borderThickness} solid ${prod?.borderLayout?.hex}` : "none",
                          borderRight: (isImageSelected === j + 1 && !data?.newLayout) ||
                            (data?.newLayout && j === component?.products?.length - 1) ||
                            (data?.newLayout && j === 0) ?
                            `${j === 0 ? "2px" : borderThickness} solid ${prod?.borderLayout?.hex}` :
                            "none",
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          borderTop: data?.newLayout || isImageSelected === j + 1 ? `${borderThickness} solid ${prod?.borderLayout?.hex}` : "none",
                          backgroundColor: data?.newLayout && j === 0 ? "#F7F4F1" : "none"
                        }}
                        onClick={() => setIsImageSelected(j + 1)}
                      >

                        {
                          prod?.mainTitle &&
                          <p className={style.mainTitleBox} style={{
                            backgroundColor: isImageSelected == j + 1 ? prod?.borderLayout?.hex : "", color: isImageSelected === j + 1 ? "#fff" : "", textAlign: data?.textAlign
                          }}>{prod?.mainTitle}</p>

                        }
                        <Image className={style.prodMainImg} image={prod?.image} alt={prod?.image?.alt} onClick={() => setIsImageSelected(j + 1)} />
                        <div className={data?.newLayout ? `${style.titleContent} ${j == 0 ? style.highlightedColumn : ""}` : `${style.prodContent}`}>
                          <div className={style.reviewTitleSubtitle} >
                            {!data?.newLayout && <ProductReviewsSnippet variants={formattedMergedVariants} />}
                            {(prod.title || prod?.prodRef?.title) && !data?.newLayout && <h4 className={style.prodTitle} style={{ textAlign: data?.textAlign ? data?.textAlign : "left" }}>{prod?.title ? prod?.title : prod?.prodRef?.title}</h4>}
                            {(prod.title || prod?.prodRef?.title) && data?.newLayout && <h2 className={style.prodTitle} style={{ textAlign: data?.textAlign ? data?.textAlign : "left" }}>{prod?.title ? prod?.title : prod?.prodRef?.title}</h2>}
                            {prod?.subtitle && !data?.newLayout && <p className={style.prodSubtitle} style={{ textAlign: data?.textAlign ? data?.textAlign : "left" }}>{prod?.subtitle}</p>}
                            {prod?.subtitle && data?.newLayout && <h4 className={style.prodSubtitleBold} style={{ textAlign: data?.textAlign ? data?.textAlign : "left" }}>{prod?.subtitle}</h4>}
                          </div>
                          {prod?.prodRef?.price && prod?.description &&
                            <div className={style.priceDescription}>
                              <p className={style.prodMoney}>{locale.collections.from} <Money value={prod?.prodRef?.price} /></p>
                              {prod?.description &&
                                <p className={style.prodSubtitle}>{prod?.description}</p>}
                            </div>
                          }
                        </div>
                      </div>
                    );
                  }

                  )}
                </div>
              </Container>
            );
          } else {
            const backgroundColor = component?.bgColor?.hex;
            const borderLayoutHex =
              i === 0 && productBorderLayout ? productBorderLayout : backgroundColor;
            let productDetailsLength = data?.section?.filter(component => component._type !== "productModule")?.length;

            return (
              <div key={i} style={{ backgroundColor }}>
                <Container>
                  <div className={`${style.productDetailsContent}${data?.newLayout ? ` ${style.productDetailsContentAllBorders}` : ""}`}>
                    {component?.column?.map((col, j) => (
                      <div
                        key={j}
                        style={getBorderStyle(j, i, productBorderLayout, secondProductBorderLayout, thirdProductBorderLayout, borderLayoutHex, productDetailsLength, isImageSelected, data?.newLayout, data?.borderColor?.hex, component?.column?.length)}
                        className={`${style.productContent} ${data?.newLayout ? `${style.columnStyle}` : ""}`}
                        onClick={() => setIsImageSelected(j === 0 ? j + 1 : j)}
                      >
                        {col?.prodDetail?.map((detail, k) => (
                          <div key={k} className={`${style.prodBox} ${data?.newLayout ? style.prodAllBorders : ""}`} style={{ minHeight: detail?.minheight || data?.newLayout ? "150px" : "250px" }}>
                            {detail?.stars && detail?.imageAbove && (
                              <img className={style.icon} src={getImagePath(detail?.stars)} alt={detail?.stars?.alt} />
                            )}
                            {detail?.textList &&
                              <div className={`${style.prodContentBlock} ${j == 1 ? style.highlightedColumn : ""}`} style={{
                                textAlign: j === 0 ? "left" : data?.textAlign || "left", justifyContent: j === 0 ? "left" : data?.textAlign || "left", marginTop: data?.newLayout ? "1.25rem" : ""
                              }}
                              >
                                <RichText blocks={detail?.textList} className={`${data?.newLayout ? style.cellContent : ""}`} />
                              </div>
                            }
                            {
                              detail?.blueBox &&
                              <div className={style.prodBlueBox}>
                                <RichText blocks={detail?.blueBox} />
                              </div>
                            }
                            {detail?.stars && !detail?.imageAbove && (
                              <img className={style.icon} src={getImagePath(detail?.stars)} alt={detail?.stars?.alt} />
                            )}
                            {(detail?.checkmark) && <div className={style.checkmark}><OrangeCheckmark /></div>}
                            {detail?.image && !detail?.roundedCorners && (<div className={style.prodImg}><Image image={detail?.image} alt={detail?.image?.alt} /></div>)}
                            {detail?.image && detail?.roundedCorners && (<div className={style.roundedCornersImg}><Image image={detail?.image} alt={detail?.image?.alt} /></div>)}
                          </div>
                        )
                        )}
                      </div>
                    ))}
                  </div>
                </Container>
              </div>
            );
          }
        })}
      </div >
    </>
  );
};

export default TableProductInformation;
